<ng-container *ngIf="!compact; else compactSwatch">
  <input [(colorPicker)]="colorHex"
         (colorPickerChange)="handleColorChange()"
         [style.background]="colorHex"
         [cpAlphaChannel]="'disabled'"
         [cpPresetColors]="presetColors"
         [value]="getColorName() + ' (' + colorHex + ')'"
         [style.color]="isLightColor() ? 'black' : 'white'"
         [cpPosition]="cpPosition"
         [cpDisabled]="disabled"
         [disabled]="disabled"
         (colorPickerOpen)="handlePickerOpen()"
         (colorPickerClose)="handlePickerClose()"
         class="form-control cursor-pointer"
         id="{{ id }}"
         name="{{ id }}">
</ng-container>

<!-- The same picker as a small square swatch, for inline use in a table row. -->
<ng-template #compactSwatch>
  <button type="button"
          [(colorPicker)]="colorHex"
          (colorPickerChange)="handleColorChange()"
          [style.background]="colorHex"
          [cpAlphaChannel]="'disabled'"
          [cpPresetColors]="presetColors"
          [cpPosition]="cpPosition"
          [cpDisabled]="disabled"
          [disabled]="disabled"
          (colorPickerOpen)="handlePickerOpen()"
          (colorPickerClose)="handlePickerClose()"
          class="capitan-color-swatch"
          [class.capitan-color-swatch-lg]="size === 'lg'"
          id="{{ id }}"
          [attr.aria-label]="ariaLabel"></button>
</ng-template>
